var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.anthenticated)?_c('Navbar',{scopedSlots:_vm._u([{key:"mian_con",fn:function(){return [_c('router-view')]},proxy:true}],null,false,4016746261)}):_c('div',{staticClass:"content_div"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }